import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { fetchCategoriesDropDown, fetchMediaTypesDropDown, fetchStatusesDropDown, fetchOrientationDropDown, getContent, getFile, deleteContent } from '../../services/contentService';
import classes from './AddContents.module.scss';
import Card from '../../components/UI/card/Card';
import Button from "../../components/UI/button/Button";
import { toast } from 'react-toastify';
import Loader from '../../components/UI/loader/Loader';
import { Icon } from '@iconify/react';
import { Dialog } from '@headlessui/react';
import { extractCssColor } from '../../components/UI/input/TagInput';
import checkPermissions from "../../services/permissions";
import { imgeURL } from '../..';

//..............................................................................................




const ViewContent = () => {
    const apiUrl = imgeURL;
    const [Id, setId] = useState('');
    const [categories, setCategories] = useState<Category[]>([]);
    const [statuses, setStatuses] = useState<Status[]>([]);
    const [mediaTypes, setMediaTypes] = useState<MediaType[]>([]);
    const [orientations, setOrientations] = useState<any[]>([]);
    const [imageUrl, setImageUrl] = useState<string>('');
    const [isLoading, setLoading] = useState(false);
    const [imgIsLoading, setimgIsLoading] = useState(true);
    const [imgDataIsLoading, setimgDataIsLoading] = useState<boolean>(true);
    const { t } = useTranslation();
    const [arTags, setArTags] = useState<string[]>([]);
    const [enTags, setEnTags] = useState<string[]>([]);
    const [arColors, setArColors] = useState<string[]>([]);
    const [enColors, setEnColors] = useState<string[]>([]);
    const [isOpen, setIsOpen] = useState(false);
    const [initialValue, setInitialValue] = useState<AssetDetails>({
        assetId: '',
        arabicTitle: '',
        englishTitle: '',
        mediaType: '',
        assetFormat: 'PNG',
        arDescription: '',
        enDescription: '',
        category: '',
        assetTagsEn: [],
        assetTagsAr: [],
        assetColorsEn: [],
        assetColorsAr: [],
        assetSize: '',
        orientation: '',
        resolution: '',
        status: '',
        modifiedBy: '',
        modifiedDate: '',
    });



    const goToEditPage = () => {
        window.location.href = ('/content/edit?id=' + Id);
    }

    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    const deleteAsset = async () => {
        try {
            await deleteContent(Id || '', true);
            toast.success(t("Content Deleted successfully!"));
            window.location.href = ('/content');
        } catch (error: any) {
            toast.error(t("Failed to delete content. Please try again."));
        }

    }

    const getItemLabel = (array: any[], id: string | number): string => {
        const item = array.find((item) => item.id === id);
        return item ? item.name : '';
    };



    // ...................................event listeners & fetch dropdown data.................................................

    useEffect(() => {
        if (mediaTypes.length && categories.length) {
            const getAssetData = async () => {
                try {
                    setimgDataIsLoading(true);
                    const id = new URLSearchParams(window.location.search).get('id');
                    setId(id || '');
                    const res: { data: AssetDetailsResponse } = await getContent(id || '');
                    const data: AssetDetailsResponse = res.data;
                    console.log(data);
                    setimgIsLoading(true);
                    setTimeout(() => {
                        setImageUrl(data?.filePath);
                        setimgIsLoading(false);
                    }, 100);
                    let temp = {
                        assetId: id || '',
                        arabicTitle: data?.arabicTitle,
                        englishTitle: data?.title,
                        mediaType: getItemLabel(mediaTypes, data?.mediaTypeId) || '',
                        assetFormat: data?.fileType,
                        arDescription: data?.arabicDescription,
                        enDescription: data?.description,
                        category: getItemLabel(categories, data?.categoryId) || '',
                        assetTagsEn: (data?.aiTags?.length) ? data?.aiTags.split(',') : [],
                        assetTagsAr: (data?.arabicAITags?.length) ? (data?.arabicAITags.includes(',') ? data?.arabicAITags.split(',') : data?.arabicAITags.split('،')) : [],
                        assetColorsEn: (data?.colors?.length) ? data?.colors.split(',') : [],
                        assetColorsAr: (data?.arabicColors?.length) ? (data?.arabicColors.includes(',') ? data?.arabicColors.split(',') : data?.arabicColors.split('،')) : [],
                        assetSize: data?.fileSize,
                        orientation: getItemLabel(orientations, data?.fileOrientation) || '',
                        resolution: data?.resolution + ' PXL',
                        status: getItemLabel(statuses, data?.status) || '',
                        modifiedBy: '',
                       modifiedDate: data?.modifiedDate || '',
                    };
                    setTimeout(() => {
                        setInitialValue({ ...temp });
                        setArColors([...temp?.assetColorsAr]);
                        setEnColors([...temp?.assetColorsEn]);
                        setArTags([...temp?.assetTagsAr]);
                        setEnTags([...temp?.assetTagsEn]);
                        setimgDataIsLoading(false);
                    }, 100);

                } catch (e: any) {
                    toast.error("Failed to get Asset data.");
                    setimgDataIsLoading(false);
                }
            }
            getAssetData();

        }

    }, [mediaTypes, categories]);

    useEffect(() => {
        const getStatuses = async () => {
            try {
                const data: Status[] = await fetchStatusesDropDown();
                setStatuses(data);

            } catch (err: any) {
                toast.error("Failed to Get Statuses.");
            }
        };
        getStatuses();
    }, []);

    useEffect(() => {
        const getOrientation = async () => {
            try {
                const OrientationResult = await fetchOrientationDropDown();
                setOrientations(OrientationResult);

            } catch (err: any) {
                toast.error("Failed to Get Orientation and MediaTypes.");
            }
        };
        getOrientation();
    }, []);

    useEffect(() => {
        const getcategories = async () => {
            try {
                const mediaTypeResult = await fetchMediaTypesDropDown();
                const categoriesResult = await fetchCategoriesDropDown();
                setCategories(categoriesResult);
                setMediaTypes(mediaTypeResult);

            } catch (err: any) {
                toast.error("Failed to Get Categories and MediaTypes.");
            }
        };
        getcategories();
    }, []);



    return (
        <>
            {/* {(!imgDataIsLoading) &&  */}
            {!imgDataIsLoading && <section>
                <div className='bread-crumbs w-full flex flex-row gap-1'>
                    <a className='text-[16px] font-thin text-gray-600' href='/content'>{t('Assets')}</a>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 18L15 12L9 6" stroke="#87939b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <div className='text-[16px] font-thin text-gray-600'>{t('view')}</div>
                </div>
                <h2 className="title mb-2 text-black text-[36px] font-bold">{initialValue?.englishTitle}</h2>
                <div className='asset-details w-full'>
                    <Card cardClasses='!p-2'>
                        <div className='add-content-container w-full flex flex-col md:flex-row py-4 px-2 gap-4'>
                            <div className='images-container w-full md:w-[50%]'>
                                {!imgIsLoading &&
                                    <div className='main-img relative h-[50%] min-h-[500px]' >
                                        <img className='w-full h-full border-[#ccc] border-[1px] object-cover !mt-0' src={apiUrl + imageUrl} alt="img" />
                                        <svg onClick={() => openModal()} className='absolute top-2 right-[5px] cursor-pointer' width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="44" height="44" rx="4" fill="#161616" fill-opacity="0.4" />
                                            <path d="M18.0668 12.3505C18.4794 12.3876 18.784 12.752 18.747 13.1646C18.71 13.5771 18.3456 13.8815 17.9331 13.8446L17.9311 13.8444L17.9237 13.8437L17.8926 13.8411C17.865 13.8388 17.8237 13.8354 17.7706 13.8313C17.6643 13.8231 17.511 13.812 17.3246 13.8007C16.9508 13.7779 16.449 13.7543 15.9304 13.7503C15.5477 13.7474 15.1673 13.7553 14.8282 13.7799L20.5273 19.4715C20.8204 19.7642 20.8207 20.2391 20.528 20.5322C20.2353 20.8253 19.7604 20.8256 19.4673 20.5329L13.7785 14.8515C13.7552 15.1846 13.7477 15.5562 13.7506 15.9301C13.7546 16.4487 13.7781 16.9506 13.8009 17.3243C13.8123 17.5107 13.8234 17.6641 13.8316 17.7703C13.8357 17.8235 13.839 17.8647 13.8414 17.8924L13.844 17.9234L13.8447 17.9309L13.8448 17.9325C13.8818 18.345 13.5774 18.7097 13.1649 18.7468C12.7523 18.7838 12.3879 18.4794 12.3508 18.0668L12.3505 18.0629L12.3496 18.0533L12.3466 18.0177C12.344 17.987 12.3404 17.9424 12.336 17.8858C12.3273 17.7726 12.3156 17.6111 12.3037 17.4156C12.2799 17.0255 12.2549 16.4954 12.2506 15.9417C12.2464 15.3925 12.2624 14.7986 12.3257 14.2883C12.3573 14.0339 12.4032 13.7791 12.4727 13.5518C12.5367 13.3428 12.6462 13.0686 12.8575 12.8573C13.0688 12.646 13.343 12.5365 13.5521 12.4725C13.7794 12.403 14.0341 12.3571 14.2885 12.3255C14.7988 12.2621 15.3928 12.2462 15.9419 12.2504C16.4956 12.2546 17.0257 12.2797 17.4158 12.3034C17.6113 12.3153 17.7729 12.327 17.886 12.3357C17.9426 12.3401 17.9872 12.3438 18.018 12.3463L18.0535 12.3494L18.0631 12.3502L18.0668 12.3505Z" fill="white" />
                                            <path d="M25.9363 31.6451C25.5238 31.6081 25.2192 31.2436 25.2562 30.831C25.2932 30.4185 25.6576 30.1141 26.0701 30.1511L26.0795 30.1519L26.1105 30.1545C26.1382 30.1568 26.1795 30.1602 26.2326 30.1643C26.3388 30.1725 26.4922 30.1836 26.6786 30.195C27.0523 30.2177 27.5542 30.2413 28.0728 30.2453C28.4555 30.2482 28.8359 30.2403 29.175 30.2157L23.4759 24.5241C23.1828 24.2314 23.1825 23.7565 23.4752 23.4634C23.7679 23.1703 24.2428 23.17 24.5358 23.4627L30.2247 29.1442C30.248 28.811 30.2555 28.4394 30.2526 28.0655C30.2486 27.5469 30.225 27.045 30.2023 26.6713C30.1909 26.4849 30.1798 26.3315 30.1716 26.2253C30.1675 26.1722 30.1641 26.1309 30.1618 26.1032L30.1592 26.0722L30.1585 26.0647L30.1584 26.0631C30.1214 25.6506 30.4258 25.2859 30.8383 25.2489C31.2509 25.2118 31.6153 25.5163 31.6523 25.9288L31.6527 25.9327L31.6535 25.9423L31.6566 25.9779C31.6591 26.0086 31.6628 26.0532 31.6671 26.1098C31.6759 26.223 31.6876 26.3845 31.6995 26.58C31.7232 26.9702 31.7483 27.5002 31.7525 28.0539C31.7568 28.6031 31.7408 29.197 31.6774 29.7073C31.6458 29.9617 31.6 30.2165 31.5304 30.4438C31.4665 30.6528 31.357 30.927 31.1457 31.1383C30.9344 31.3496 30.6602 31.4591 30.4511 31.5231C30.2238 31.5926 29.9691 31.6385 29.7146 31.6701C29.2043 31.7335 28.6104 31.7494 28.0613 31.7452C27.5076 31.741 26.9775 31.7159 26.5874 31.6922C26.3918 31.6803 26.2303 31.6686 26.1171 31.6599C26.0605 31.6555 26.016 31.6519 25.9852 31.6493L25.9497 31.6462L25.9401 31.6454L25.9363 31.6451Z" fill="white" />
                                            <path d="M25.2562 13.1646C25.2192 12.752 25.5238 12.3876 25.9363 12.3505L25.9401 12.3502L25.9497 12.3494L25.9852 12.3463C26.016 12.3438 26.0605 12.3401 26.1171 12.3357C26.2303 12.327 26.3918 12.3153 26.5874 12.3034C26.9775 12.2797 27.5076 12.2546 28.0613 12.2504C28.6104 12.2462 29.2043 12.2621 29.7146 12.3255C29.9691 12.3571 30.2238 12.403 30.4511 12.4725C30.6602 12.5365 30.9344 12.646 31.1457 12.8573C31.357 13.0686 31.4665 13.3428 31.5304 13.5518C31.6 13.7791 31.6458 14.0339 31.6774 14.2883C31.7408 14.7986 31.7568 15.3925 31.7525 15.9417C31.7483 16.4954 31.7232 17.0255 31.6995 17.4156C31.6876 17.6111 31.6759 17.7726 31.6671 17.8858C31.6628 17.9424 31.6591 17.987 31.6566 18.0177L31.6535 18.0533L31.6527 18.0629L31.6523 18.0668C31.6153 18.4794 31.2509 18.7838 30.8383 18.7468C30.4258 18.7097 30.1214 18.345 30.1584 17.9325L30.1585 17.9309L30.1592 17.9234L30.1618 17.8924C30.1641 17.8647 30.1675 17.8235 30.1716 17.7703C30.1798 17.6641 30.1909 17.5107 30.2023 17.3243C30.225 16.9506 30.2486 16.4487 30.2526 15.9301C30.2555 15.5562 30.248 15.1846 30.2247 14.8515L24.5358 20.5329C24.2428 20.8256 23.7679 20.8253 23.4752 20.5322C23.1825 20.2391 23.1828 19.7642 23.4759 19.4715L29.175 13.7799C28.8359 13.7553 28.4555 13.7474 28.0728 13.7503C27.5542 13.7543 27.0523 13.7779 26.6786 13.8007C26.4922 13.812 26.3388 13.8231 26.2326 13.8313C26.1795 13.8354 26.1382 13.8388 26.1105 13.8411L26.0795 13.8437L26.072 13.8444L26.0701 13.8446C25.6576 13.8815 25.2932 13.5771 25.2562 13.1646Z" fill="white" />
                                            <path d="M18.0668 31.6451C18.4794 31.6081 18.784 31.2436 18.747 30.831C18.71 30.4185 18.3456 30.1141 17.9331 30.1511L17.9237 30.1519L17.8926 30.1545C17.865 30.1568 17.8237 30.1602 17.7706 30.1643C17.6643 30.1725 17.511 30.1836 17.3246 30.195C16.9508 30.2177 16.449 30.2413 15.9304 30.2453C15.5477 30.2482 15.1673 30.2403 14.8282 30.2157L20.5273 24.5241C20.8204 24.2314 20.8207 23.7565 20.528 23.4634C20.2353 23.1703 19.7604 23.17 19.4673 23.4627L13.7785 29.1442C13.7552 28.811 13.7477 28.4394 13.7506 28.0655C13.7546 27.5469 13.7781 27.045 13.8009 26.6713C13.8123 26.4849 13.8234 26.3315 13.8316 26.2253C13.8357 26.1722 13.839 26.1309 13.8414 26.1032L13.844 26.0722L13.8447 26.0647L13.8448 26.0631C13.8818 25.6506 13.5774 25.2859 13.1649 25.2489C12.7523 25.2118 12.3879 25.5163 12.3508 25.9288L12.3505 25.9327L12.3496 25.9423L12.3466 25.9779C12.344 26.0086 12.3404 26.0532 12.336 26.1098C12.3273 26.223 12.3156 26.3845 12.3037 26.58C12.2799 26.9702 12.2549 27.5002 12.2506 28.0539C12.2464 28.6031 12.2624 29.197 12.3257 29.7073C12.3573 29.9617 12.4032 30.2165 12.4727 30.4438C12.5367 30.6528 12.6462 30.927 12.8575 31.1383C13.0688 31.3496 13.343 31.4591 13.5521 31.5231C13.7794 31.5926 14.0341 31.6385 14.2885 31.6701C14.7988 31.7335 15.3928 31.7494 15.9419 31.7452C16.4956 31.741 17.0257 31.7159 17.4158 31.6922C17.6113 31.6803 17.7729 31.6686 17.886 31.6599C17.9426 31.6555 17.9872 31.6519 18.018 31.6493L18.0535 31.6462L18.0631 31.6454L18.0668 31.6451Z" fill="white" />
                                        </svg>

                                    </div>}
                                {imgIsLoading &&
                                    <div className='h-[50%] min-h-[500px] w-full bg-[#F2F2F2] bg-opacity-80 animate-pulse'>

                                    </div>}
                            </div>
                            <div className={'w-full  md:w-[50%]'}>

                                <div className={'asset-id w-full flex justify-start items-start gap-3 py-3 mb-2 '}>
                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Asset ID*
                                    </h4>
                                    <div className="value">{initialValue.assetId}</div>
                                </div>
                                <div className={'asset-en-title w-full flex justify-start items-start gap-3 py-3 mb-2 '}>
                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Asset Title EN*
                                    </h4>
                                    <div className="value">{initialValue.englishTitle}</div>
                                </div>

                                <div className={'asset-ar-title w-full flex justify-start items-start gap-3 py-3 mb-2 '}>
                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Asset Title AR*
                                    </h4>
                                    <div className="value">{initialValue.arabicTitle}</div>
                                </div>

                                <div className={'asset-type w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">Asset Type*</h4>
                                    <div className="value">{initialValue.mediaType}</div>

                                </div>

                                <div className={'asset-format w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Asset Format*
                                    </h4>
                                    <div className="value">{initialValue.assetFormat}</div>

                                </div>

                                <div className={'asset-en-descripition w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Asset Description EN
                                    </h4>
                                    <div className="value">{initialValue.enDescription}</div>

                                </div>

                                <div className={'asset-ar-descripition w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Asset Description AR
                                    </h4>
                                    <div className="value">{initialValue.arDescription}</div>

                                </div>

                                <div className={'asset-category w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">Category*</h4>
                                    <div className="value">{initialValue.category}</div>

                                </div>

                                <div className={'asset-en-tags w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">Tags EN*</h4>
                                    <div className="value flex gap-1"> {enTags.map((tag) =>
                                        <span className='p-1' style={{ border: '1px solid #c9c7c7', borderRadius: '4px' }}>
                                            {tag}
                                        </span>)}
                                    </div>

                                </div>


                                <div className={'asset-ar-tags w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">Tags AR*</h4>
                                    <div className="value flex gap-1"> {arTags.map((tag) =>
                                        <span className='p-1' style={{ border: '1px solid #c9c7c7', borderRadius: '4px' }}>
                                            {tag}
                                        </span>)}
                                    </div>

                                </div>

                                <div className={'asset-en-colors w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">Colors EN*</h4>
                                    <div className="value flex gap-1"> {enColors.map((color, index) =>
                                        <div className='p-2 flex justify-center items-center gap-1 ' style={{ border: '1px solid #c9c7c7', borderRadius: '4px' }}>
                                            <div className="w-[15px] h-[15px]" style={{ background: extractCssColor(enColors[index].toLowerCase()), border: '1px solid grey' }}></div>
                                            <div>{color}</div>
                                        </div>)}
                                    </div>

                                </div>

                                <div className={'asset-ar-colors w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                   <h4 className="font-bold text-[18px] whitespace-nowrap">Colors AR*</h4>
                                         <div className="value flex gap-1">
                                           {arColors.map((color, index) =>
                                             <div className='p-2 flex justify-center items-center gap-1' style={{ border: '1px solid #c9c7c7', borderRadius: '4px' }}>
                                               <div className="w-[15px] h-[15px]" style={{ background: extractCssColor(enColors?.[index]?.toLowerCase() || ''), border: '1px solid grey' }}></div>
                                               <div>{color}</div>
                                             </div>
                                           )}
                                         </div>

                                </div>

                                <div className={'asset-size w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Asset Size*
                                    </h4>
                                    <div className="value">{initialValue.assetSize}</div>

                                </div>
                                <div className={'orientation w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">Orientation*</h4>
                                    <div className="value">{initialValue.orientation}</div>

                                </div>
                                <div className={'resolution w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Resolution*
                                    </h4>
                                    <div className="value">{initialValue.resolution}</div>

                                </div>
                                <div className={'asset-status w-full flex justify-start items-start gap-3 py-3 mb-2 '}>

                                    <h4 className="font-bold text-[18px] whitespace-nowrap">Status*</h4>
                                    <div className={`${(initialValue?.status).toLowerCase() === 'draft' ? 'text-[#B54708]' :
                                        (initialValue?.status).toLowerCase() === 'published' ? 'text-[#175CD3]' : 'text-gray-500'}`}>{initialValue.status.toUpperCase()}</div>

                                </div>
                                <div className="modified-date w-full flex justify-start items-start gap-3 py-3 mb-2">
                                    <h4 className="font-bold text-[18px] whitespace-nowrap">
                                        Modified Date*
                                    </h4>
                                    <div className="value"> {initialValue.modifiedDate ? (() => {
                                                const date = new Date(initialValue.modifiedDate);
                                                console.log(date);
                                                console.log(initialValue.modifiedDate);
                                                if (isNaN(date.getTime())) {
                                                    return "-"; 
                                                  }
                                                const day = String(date.getDate()).padStart(2, '0');
                                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                                const year = date.getFullYear();
                                                return `${day}/${month}/${year}`;
                                            })() : "-"}
                                    </div>
                                </div>

                                <div className={classes.saveDetails + ' w-full flex justify-end items-end'}>
                                    <div className={classes.btnwrapper}>
                                    {checkPermissions(["DeleteContent"]) && (<Button className='!bg-[#e2e2e2] !text-[red] !border-[#B54708] !border-[1px]' type="button" onClick={() => deleteAsset()} >
                                            <Icon icon="fluent:delete-24-regular" width="20" />
                                        </Button>
                                    )}
                                     {checkPermissions(["UpdateContent"]) && (
                                        <Button className='!bg-primary-50 !text-white flex flex-n gap-2 ' type="submit" onClick={() => goToEditPage()} >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6703 1.49534C13.6574 0.908247 14.8749 0.88985 15.8789 1.44725C16.2954 1.67846 16.6753 2.06679 17.2402 2.64431L17.3936 2.80103C17.9606 3.37981 18.34 3.76717 18.5653 4.19064C19.1058 5.20655 19.0882 6.43555 18.5185 7.43514C18.281 7.85179 17.8905 8.22769 17.3073 8.78911L9.29173 16.5094C8.14103 17.6181 7.43178 18.3015 6.53434 18.652C5.63559 19.0031 4.65838 18.9773 3.07738 18.9357L2.67158 18.9251C2.43987 18.9191 2.20564 18.913 2.01225 18.8807C1.79014 18.8437 1.52633 18.7585 1.31763 18.5217C1.11079 18.2869 1.05771 18.016 1.04529 17.7931C1.03431 17.5961 1.05275 17.36 1.07129 17.1228L1.10539 16.6851C1.21312 15.2996 1.27898 14.4526 1.61342 13.6829C1.94829 12.9121 2.52037 12.2925 3.45375 11.2815L11.3441 2.73266C11.8923 2.13833 12.2608 1.73888 12.6703 1.49534ZM15.2722 2.54012C14.6574 2.1988 13.9143 2.20985 13.3092 2.5697C13.0773 2.70765 12.8393 2.95572 12.1876 3.66186L12.1196 3.7355L16.3549 7.97081L16.3619 7.9641C17.0524 7.29906 17.2962 7.05528 17.4325 6.8162C17.7898 6.18927 17.801 5.41547 17.4618 4.77774C17.3323 4.5345 17.0955 4.28337 16.4245 3.59793C15.7526 2.91161 15.5078 2.67095 15.2722 2.54012ZM4.4507 12.0444L11.2711 4.65479L15.4545 8.83811L8.52551 15.5118C7.24006 16.7499 6.71606 17.2391 6.07956 17.4877C5.44445 17.7358 4.73747 17.7286 2.97104 17.6824L2.73772 17.6763C2.60479 17.6729 2.4995 17.6701 2.40909 17.6653C2.36224 17.6629 2.32373 17.6601 2.2918 17.657C2.29213 17.5568 2.30231 17.4151 2.32008 17.1871L2.34257 16.8983C2.46246 15.3596 2.51902 14.7354 2.75989 14.181C3.0003 13.6276 3.41395 13.1677 4.4507 12.0444Z" fill="white" />
                                                <path d="M11.667 17.7084C11.3218 17.7084 11.042 17.9882 11.042 18.3334C11.042 18.6786 11.3218 18.9584 11.667 18.9584H18.3337C18.6788 18.9584 18.9587 18.6786 18.9587 18.3334C18.9587 17.9882 18.6788 17.7084 18.3337 17.7084H11.667Z" fill="white" />
                                            </svg>
                                            {t("edit")}
                                        </Button>
                                     )}
                                    </div>
                                </div>



                            </div>
                        </div>
                    </Card>
                </div>
            </section>}
            {/* }  */}
            {(imgDataIsLoading) &&
                <div className='w-full h-[80vh] flex justify-center items-center p-2 border-[1px] border-[#bbbbbb]  rounded-[4px]
         bg-[#F2F2F2] bg-opacity-80 animate-pulse'>
                    <Loader />
                </div>}
            {/* ----------------------image popup--------------------------------------- */}
            <Dialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                className="fixed inset-0 z-10 flex items-center justify-center p-4 bg-black bg-opacity-50">
                <Dialog.Overlay className="fixed inset-0" />

                <div className="bg-transparent flex justify-center items-center rounded-lg overflow-hidden shadow-xl w-auto max-w-[70%] mx-auto">
                    <div className='relative '>
                        <img src={apiUrl + imageUrl} alt="Preview" className="w-full !max-h-[70vh] !max-w-[70vw] h-auto mt-0" />
                        <div onClick={closeModal} className={`absolute top-[1%]  cursor-pointer right-[1%]`}  >
                            <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="38" height="38" rx="4" fill="#625C76" fill-opacity="0.5" />
                                <path d="M25 13L13 25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 13L25 25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/* ------------------------------------------------------------------------- */}
        </>
    );
};

export default ViewContent;



interface Category {
    id: string | number;
    name: string;
}

interface MediaType {
    id: string | number;
    name: string;
}

type Status = {
    id: number;
    name: string;
    description: string
}

type AssetDetailsResponse = {
    id: string;
    categoryId: string;
    mediaTypeId: string;
    categoryName: string;
    mediaTypeName: string;
    title: string;
    arabicTitle: string;
    description: string;
    arabicDescription: string;
    aiTags: string;
    arabicAITags: string;
    aiDescription: string;
    arabicAIDescription: string;
    colors: string;
    arabicColors: string;
    fileType: string;
    filePath: string;
    fileWidth: number;
    fileHeight: number;
    fileSize: string;
    resolution: string;
    modifiedDate: string | null;
    statusModifiedDate: string | null;
    status: number;
    fileOrientation: number;
}

type AssetDetails = {
    assetId: string;
    arabicTitle: string;
    englishTitle: string;
    mediaType: string;
    assetFormat: string;
    arDescription: string;
    enDescription: string;
    category: string;
    assetTagsEn: string[];
    assetTagsAr: string[];
    assetColorsEn: string[];
    assetColorsAr: string[];
    assetSize: string;
    orientation: string;
    resolution: string;
    status: string;
    modifiedBy: string;
    modifiedDate: string;
}


